import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { ThemedToaster } from './components/ThemedToaster'
import './index.css'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root 未找到')

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
      {/* 主题由 index.html 的首帧内联脚本预置，这里只需让 sonner 跟着走 */}
      <ThemedToaster />
    </BrowserRouter>
  </StrictMode>,
)
